export default function WhySection() {
  const cards = [
    {
      icon: 'ri-database-2-line',
      title: 'Updated Product Database',
      desc: 'Access organized collections covering trending categories and popular products, refreshed regularly to keep you in the loop with what matters most in the shopping world.',
      image: 'https://readdy.ai/api/search-image?query=Organized%20fashion%20product%20catalog%20display%20with%20neatly%20arranged%20shoes%20clothing%20and%20accessories%20on%20clean%20white%20shelving%2C%20modern%20retail%20aesthetic%2C%20soft%20natural%20lighting%2C%20editorial%20merchandising%20photography%2C%20warm%20cream%20tones&width=400&height=280&seq=why-card-1-v2&orientation=landscape',
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Faster Product Research',
      desc: 'Save time by comparing products through structured spreadsheet information. Stop jumping between tabs — everything you need is organized and accessible in one place.',
      image: 'https://readdy.ai/api/search-image?query=Sleek%20modern%20laptop%20on%20marble%20desk%20displaying%20organized%20product%20comparison%20dashboard%20with%20clean%20charts%20and%20grid%20layout%2C%20minimal%20workspace%20with%20warm%20coffee%20cup%2C%20soft%20morning%20light%2C%20productive%20atmosphere&width=400&height=280&seq=why-card-2-v2&orientation=landscape',
    },
    {
      icon: 'ri-image-line',
      title: 'QC Photo Understanding',
      desc: 'Learn how quality checking information helps improve buying decisions. Understand what to look for in product images before making a purchase commitment.',
      image: 'https://readdy.ai/api/search-image?query=Magnifying%20glass%20hovering%20over%20detailed%20product%20closeup%20on%20light%20surface%2C%20quality%20inspection%20concept%2C%20clean%20minimal%20photography%2C%20soft%20shadows%2C%20warm%20natural%20lighting%2C%20professional%20product%20review%20scene&width=400&height=280&seq=why-card-3-v2&orientation=landscape',
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Beginner Friendly Guides',
      desc: 'Follow simple guides created for new users. No prior experience needed — our step-by-step approach makes product discovery approachable for everyone.',
      image: 'https://readdy.ai/api/search-image?query=Open%20stylish%20guidebook%20with%20colorful%20tabs%20and%20handwritten%20notes%20on%20clean%20desk%2C%20beginner%20tutorial%20concept%2C%20warm%20inviting%20atmosphere%2C%20soft%20daylight%2C%20organized%20learning%20materials%2C%20modern%20lifestyle%20photography&width=400&height=280&seq=why-card-4-v2&orientation=landscape',
    },
  ];

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-4">
          Why Thousands Of Users Search For VigorBuy Spreadsheet
        </h2>
        <p className="text-center text-foreground-500 text-sm md:text-base mb-12 max-w-2xl mx-auto">
          Discover why shoppers worldwide choose VigorBuy Spreadsheet as their go-to product research companion
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {cards.map((card, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl border border-background-200/60 hover:border-primary-200 transition-all group cursor-default overflow-hidden"
            >
              <div className="w-full h-36 md:h-40 overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  title={`VigorBuy Spreadsheet ${card.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-5">
                <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center mb-3 group-hover:bg-primary-200 transition-colors">
                  <i className={`${card.icon} text-primary-500 text-lg`}></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                  {card.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}